import { Endpoint } from './enums';
import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType} from './dr-object';
import { TemplateType } from '../models/template';


export class LoadFileProjectTemplateViewModel extends DrObject {

    model: Partial<LoadFileProjectTemplate>;

    constructor(value: Partial<LoadFileProjectTemplate>) {
        super(DrObjectType.LOAD_FILE_IMPORT);
        if (value) {
            this.model = value;
        }
        this.templateType = TemplateType.LOADFILE_SETTINGS;
    }
}


export class LoadFileProjectTemplate extends DrEntity {
    availableLoadFileFields: any[];
    defaultProfile: boolean;
    description: string;
    encodingType: string;
    entries: any[];
    id: string;
    loadFileType: string;
    loadImages: boolean;
    loadMode: string;
    name: string;
    preserveFamily: boolean;
    projectId: string;
    specialCharacters: any[];
    version: number;

    constructor(value?: Partial<LoadFileProjectTemplate>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }

    setAsDefaultRequestInfo(): [Endpoint, any] {
        return [ Endpoint.projectManager_setLoadFileMetadataProfile, {
            availableLoadFileFields: this.availableLoadFileFields,
            defaultProfile: true,
            description: this.description,
            encodingType: this.encodingType,
            entries: this.entries,
            loadFileType: this.loadFileType,
            loadImages: this.loadImages,
            loadMode: 'REPLACE',
            name: this.name,
            preserveFamily: this.preserveFamily,
            profileHandle: this.id,
            specialCharacters: this.specialCharacters,
            version: this.version
        } ];
    }
}
